export enum FieldType {
    TEXT = 'TEXT',
    INTEGER = 'INTEGER',
    DECIMAL = 'DECIMAL',
    DATE = 'DATE',
    RADIO = 'RADIO',
    SELECT = 'SELECT',
    CHECKBOX = 'CHECKBOX',
    GROUP = 'GROUP'
}



// WEBPACK FOOTER //
// ./src/models/field-builder/field-type.ts